import styled from 'styled-components';
import { TableEvenOdd } from '../../../../../account/styles';
import { Button, Pagination } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Content } from 'antd/es/layout/layout';
import { IReportSMS, IResponseDataTable } from '../../../../interfaces/apis';
import { SMSReportParams } from '../../../../../../services/reportApis';
import { formatCurrency } from '../../../../../../utils/formatCurrency';
import { useNavigate } from 'react-router-dom';

interface IReportSMSTableProps {
  data: IResponseDataTable<IReportSMS> | undefined;
  params: SMSReportParams;
  loading?: boolean;
  setParams: (params: SMSReportParams) => void;
}

const ReportSMSTable = ({ data, params, loading, setParams }: IReportSMSTableProps) => {
  const navigate = useNavigate();

  const columns: ColumnsType<any> = [
    {
      title: 'Business Name',
      dataIndex: 'shopName',
      className: 'shopName',
      render: (value: string, record: IReportSMS) => {
        return (
          <Button
            type='link'
            onClick={() => navigate(`/salon/${record.shopId}`)}
            style={{ padding: 0 }}
          >
            {value}
          </Button>
        );
      }
    },
    {
      title: 'Email',
      dataIndex: 'email',
      className: 'email',
    },
    {
      title: 'Total Sent',
      dataIndex: 'totalSent',
      className: 'totalSent',
    },
    {
      title: 'Total Cost',
      dataIndex: 'totalCost',
      className: 'totalCost',
      render: (value: number) => {
        return formatCurrency(value);
      }
    },
        {
      title: 'OTP',
      dataIndex: 'totalOtp',
      className: 'totalOtp',
    },
        {
      title: 'Appointments',
      dataIndex: 'totalAppointment',
      className: 'totalAppointment',
    },
        {
      title: 'Marketings',
      dataIndex: 'totalMarketing',
      className: 'totalMarketing',
    },
        {
      title: 'Others',
      dataIndex: 'totalOthers',
      className: 'totalOthers',
    },
  ];

  const handleChangePage = (newPage: number) => {
    setParams({ ...params, page: newPage });
  };

  return (
    <Container>
      <TableContentStyled
        loading={loading}
        columns={columns}
        dataSource={data?.content || []}
        rowKey='id'
        pagination={false}
      />

      <PagingStyled>
        <Pagination
          current={params.page}
          total={data?.totalElements}
          pageSize={10}
          onChange={handleChangePage}
          showSizeChanger={false}
        />
      </PagingStyled>
    </Container>
  );
};

export default ReportSMSTable;

const Container = styled.div`
  flex: 1;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

const TableContentStyled = styled(TableEvenOdd)`
  && .dateTime {
    width: 20%;
  }

  && .amount {
    width: 10%;
  }

  && .note {
    width: 15%;
  }

  && .type {
    width: 10%;
  }

  && .processedDate {
    width: 15%;
  }

  && .status {
    width: 10%;
  }

  && .progress {
    background-color: #eee;
    border-radius: 10px;
    display: inline-flex;
    font-size: 0.75rem;
    height: 20px;
    line-height: 0;
    overflow: hidden;
    position: relative;
    width: 104px;
  }

  && .progress span {
    color: rgba(245, 118, 127, 1);
    font-size: 12px;
    font-weight: 700;
    left: 0;
    position: absolute;
    right: 0;
    top: 50%;
    text-align: center;
  }

  && .progress-bar {
    background-color: rgba(255, 229, 231, 1);
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    text-align: center;
    transition: width 0.6s ease;
    white-space: nowrap;
  }

  && .coupon-label-status {
    border-radius: 2px;
    color: #1d2129;
    font-size: 14px;
    font-weight: 500;
    gap: 10px;
    height: 28px;
    padding: 4px 8px;
    width: 60px;
  }

  && .btn-delete,
  .btn-edit {
    background: transparent;
    border: none;
    padding: 8px;
  }

  && .btn-delete:hover {
    background: rgba(245, 118, 127, 1) !important;
    border: none !important;
  }

  && .btn-edit:hover {
    background: var(--blue, #008bff) !important;
    border: none !important;
  }

  thead > tr > th.ant-table-cell {
    padding: 8px 16px;
    p {
      margin: 0;
    }
  }
`;

const PagingStyled = styled(Content)`
  text-align: right;
  margin-top: 10px;
`;
